import galleryHtml from './gallery.component.html';
import GalleryImage from "./galleryImage.class";
import GalleryThumbnail from "./galleryThumbnail.class";

class GalleryController {
    constructor($scope, $timeout, $window, $sce, $http, $rootScope, CropService) {
        'ngInject';

        this.$scope = $scope;
        this.$scope.safeApply = function (fn) {
            let phase = this.$root.$$phase;
            if (phase === '$apply' || phase === '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };

        this.$timeout = $timeout;
        this.$window = $window;
        this.$sce = $sce;
        this.$http = $http;
        this.limit = 7;
        this.showFull = false;
        this.supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;
        this.handleKeyboardEvent = ($event) => {
            this.handleKeyboard($event);
            this.$scope.safeApply();
        };
        this.thumbnailsRange = {
            from: 0,
            to: 7
        }
        this.zoomEnabled = false;
        this.youtube = false;
        this.images = [];
        this.images2 = [];
        this.images2List = null;
        this.thumbnails2List = null;
        this.galleryPosition = 0;
        this.thumbnailsPosition = 0;
        this.thumbnails2 = null;
        this.currentIndex = null;
        this.currentImage = null;
        this.dragging = false;
        this.zoomDragging = false;
        this.dragStartPosition = null;
        this.galleryPositionDelta = 0;
        this.previewWidth = 0;
        this.thumbnailsDesktopDisplay = 0;
        this.index = 0;
        this.maxHeight = 'unset';
        this.aspectRatio = 1.33;
        this.playVideo = false;
        this.customImage = null;
        this.customImageOriginal = null;
        this.customImageLoading = false;
        this.CropService = CropService;

        let ctrl = this;

        $scope.processFile = function(formFile) {
            if (!formFile) {
                return;
            }

            const voucherImage = ctrl.images2.find(image => image.data.type === 'voucher');

            if (!voucherImage) {
                return;
            }

            voucherImage.setCustomData();

            const reader = new FileReader();
            const localScope = this.$scope;

            reader.readAsDataURL(formFile.files[0]);

            reader.onprogress = () => {
                ctrl.customImageLoading = true;
            }

            reader.onload = () => {
                ctrl.customImageLoading = false;
                ctrl.customImage = reader.result;

                if (!ctrl.setCustomImage || typeof ctrl.setCustomImage != 'function') {
                    return;
                }

                const acceptedImageTypes = ['image/jpeg', 'image/png'];

                if (!acceptedImageTypes.includes(formFile.files[0]['type'])) {
                    voucherImage.setCustomDataError('Nieprawidłowy typ pliku (wymagany jpg lub png)');
                    return;
                } else {
                    voucherImage.setCustomDataError();
                }

                ctrl.CropService.resizeImage(ctrl.customImage, 1800, 1800, (resizedImage) => {
                    ctrl.customImage = resizedImage;
                    voucherImage.setCustomData(ctrl.customImage);

                    $scope.safeApply();

                    if (!ctrl.change || typeof ctrl.change != 'function') {
                        return;
                    }

                    ctrl.change({imageUrl: voucherImage.url, image: ctrl.currentImage});
                    ctrl.openImageCropModal();
                });
            };
        }

        $rootScope.$on('selectCustomImage', () => {
            const productHeaderPositionTop= document.getElementById('product-header').getBoundingClientRect().top
                + document.documentElement.scrollTop - document.getElementsByClassName('header-top')[0].offsetHeight;
            window.scrollTo(0, productHeaderPositionTop);
            this.setCurrent(this.images2[this.images2.length - 1].data.url);
        })
    }

    clearCustomImage(image) {
        image.setCustomData(null);

        if (this.change && typeof this.change === 'function') {
            this.change({imageUrl: image.url, image: this.currentImage});
        }
    }

    get thumbnails() {
        return this.images.slice(this.thumbnailsRange.from, this.thumbnailsRange.to).map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    get preparedImages() {
        return this.images.map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    prepareImages2List() {
        if (!this.images2List) {
            this.images2List = this.imagesList.map(image => new GalleryImage(image));
            this.thumbnails2List = this.imagesList.map(image => new GalleryThumbnail(image.url, image.variant_id));
        }
    }

    $onInit() {
        if (!this.thumbnailsDisplay) {
            this.thumbnailsDisplay = 7;
        }

        if (this.fullscreen) {
            this.$scope.$on('closeFullscreen', () => {
                this.triggerOnCloseEvent();
            });
        }

        this.$timeout(() => {
            this.limit = Number.MAX_SAFE_INTEGER;
        }, 5000);

        this.$scope.clickOutside = () => {
            if (!this.showFull) return;

            this.showFull = false;
            this.$scope.safeApply();
        };

        angular.element(this.$window).bind('keydown', this.handleKeyboardEvent);

        angular.element(this.$window).bind('resize', () => {
            this.setThumbnailsInRowNumber(() => {
                this.$scope.safeApply();
            });
        });

        if (this.autoScale === 'true') {
            this.resizeGallery();
            let resizeTimeout = null;

            const onWindowStateChange = () => {
                if (resizeTimeout) {
                    this.$timeout.cancel(resizeTimeout);
                }
                resizeTimeout = this.$timeout(() => {
                    this.resizeGallery()
                }, 350);
            }

            window.addEventListener('load', onWindowStateChange)
            window.addEventListener('resize', onWindowStateChange);

            const observer = new MutationObserver(onWindowStateChange);
            observer.observe(document.getElementsByClassName('gallery-preview')[0], {attributes: true, childList: true, subtree: true});
        }

        this.setThumbnailsInRowNumber();
        this.setCurrent(this.current, null, true);
    }

    get galleryMaxHeight() {
        return this.maxHeight;
    }

    resizeGallery() {
        if (window.innerWidth < 992) {
            this.maxHeight = 'unset';
            return;
        }

        const galleryPreview = document.getElementsByClassName('gallery-preview')[0];
        const galleryPreviewPositionTop = galleryPreview.getBoundingClientRect().top;
        let galleryPreviewWidth = galleryPreview.getBoundingClientRect().width;
        const windowHeight = window.innerHeight - 15;

        let maxHeightNumber = windowHeight - galleryPreviewPositionTop;

        if (maxHeightNumber < 300) {
            maxHeightNumber = 300;
        }

        if (galleryPreviewWidth / maxHeightNumber < 1.5) {
            maxHeightNumber = galleryPreviewWidth / 1.5;
        }

        this.maxHeight = maxHeightNumber + 'px';
    }

    $onDestroy() {
        angular.element(this.$window).unbind('keydown', this.handleKeyboardEvent);
    }

    $onChanges(changesObj) {

        this.prepareImages2List();
        let duplicateFiles = [];

        // Remove duplicate files
        const currentFileId = this.images2List.find(image => image.data.url === this.current).data.file_id;

        let variantImages = [];
        let variantVideos = [];
        let productImages = [];
        let productVideos = [];

        if (this.variantId) {
            variantImages = this.images2List.filter(image => {
                if (duplicateFiles[image.data.file_id] || parseInt(image.data.variant_id) !== parseInt(this.variantId)) {
                    return false;
                }
                if (image.data.file_id) {
                    duplicateFiles[image.data.file_id] = true;
                }
                if (image.data.video && parseInt(image.data.variant_id) === parseInt(this.variantId)) {
                    variantVideos.push(image);
                    return false;
                }
                return true;
            });
        }

        productImages = this.images2List.filter(image => {
            if (duplicateFiles[image.data.file_id] || image.data.variant_id) {
                return false;
            }
            if (image.data.file_id) {
                duplicateFiles[image.data.file_id] = true;
            }
            if (image.data.video) {
                productVideos.push(image);
                return false;
            }
            return true;
        });

        this.images2 = [];

        /*
            P - Zdjęcie produktu
            Y - Video produktu
            X - Video wariantu
            W - Zdjęcie wybranego wariantu
        */

        if (this.variantId) {
            // Kolejność: WX…Y…W.…P…
            if (variantImages && variantImages.length > 0) {
                this.images2.push(variantImages[0]);
            }
            if (variantVideos && variantVideos.length > 0) {
                this.images2 = this.images2.concat(variantVideos);
            }
            if (productVideos && productVideos.length > 0) {
                this.images2 = this.images2.concat(productVideos);
            }
            if (variantImages && variantImages.length > 1) {
                this.images2 = this.images2.concat(variantImages.slice(1));
            }
            if (productImages && productImages.length > 0) {
                this.images2 = this.images2.concat(productImages);
            }
        } else {
            // Kolejność: PY…P…
            if (productImages && productImages.length > 0) {
                this.images2.push(productImages[0]);
            }
            if (productVideos && productVideos.length > 0) {
                this.images2 = this.images2.concat(productVideos);
            }
            if (productImages && productImages.length > 1) {
                this.images2 = this.images2.concat(productImages.slice(1));
            }
        }

        this.thumbnails2 = this.images2.map(image => {
            return this.thumbnails2List.find(thumbnail => image.data.url === thumbnail.originalUrl && image.data.variant_id === thumbnail.variantId);
        });

        this.setCurrent(this.current, null, true);

        const index = this.index;

        if (index > this.thumbnailsRange.from && index < this.thumbnailsRange.to - 1) return;
    }

    handleKeyboard($event) {

        if ($event.which === 90) { //z
            if (this.zoomEnabled) {
                this.disableZoom();
            } else {
                this.enableZoom();
            }
            this.$scope.safeApply();
        }

        if (!this.fullscreen) {
            return;
        }

        $event.stopPropagation();
        $event.preventDefault();

        switch ($event.which) {
            case 27:
                this.triggerOnCloseEvent();
                break;
            case 37:
                this.prev();
                break;
            case 39:
                this.next();
                break;
        }
    }

    closeChildFull($event) {
        if ($event.target.classList.contains('gallery-container') || $event.target.classList.contains('gallery-thumbnails-bar')) {
            this.$scope.$broadcast('closeFullscreen');
        }
    }

    closeFull($event = null) {
        if ($event) $event.stopPropagation();
        this.showFull = false;
    }

    triggerOnCloseEvent() {
        if (this.onClose && typeof (this.onClose) === 'function') {
            this.onClose({imageUrl: this.current});
        }
    }

    openFull($event = null) {
        if (this.zoomEnabled) {
            return;
        }

        if ($event) {
            $event.srcEvent.stopPropagation();
        }

        if (this.currentImage && this.currentImage.youTubeHash) {
            this.playYoutubeVideo(this.currentImage.youTubeHash);
        } else if(this.currentImage && this.currentImage.data.type !== 'voucher') {
            this.showFull = true;
        }
    }

    onCloseEvent(url) {
        this.closeFull();
        if (url) {
            this.setCurrent(url);
        }
    }

    setCurrent(url, $event = null, centerThumbnails = false) {
        if ($event) $event.stopPropagation();

        this.disableZoom();
        this.youtube = this.checkYoutubeHash(url);
        this.current = url;
        this.galleryPositionDelta = 0;

        let previousIndex = this.currentIndex;

        this.images2.forEach((image, index) => {
            if (this.current === image.data.url) {
                this.index = this.currentIndex = index;
                this.currentImage = image;
                if (image.aspectRatio) {
                    this.aspectRatio = image.aspectRatio;
                }

                image.loadSource((type, img) => {
                    if (this.fullscreen) {
                        image.aspectRatio = this.aspectRatio = type === 'image' && img ? img.width / img.height : 1.33;
                    }
                    if (type === 'image') {
                        this.$scope.safeApply();
                    }
                });
            }
        });

        if (centerThumbnails) {
            this.thumbnailsCenterToCurrent();
        } else {
            let direction = 0;

            if (previousIndex !== null && this.currentIndex > previousIndex) {
                direction = 1;
            } else if (previousIndex !== null && this.currentIndex < previousIndex) {
                direction = -1;
            }

            if (direction === 1) {
                this.thumbnailsForward();
            }

            if (direction === -1) {
                this.thumbnailsRewind();
            }
        }

        if (!this.change || typeof this.change != 'function') return;

        this.change({imageUrl: url, image: this.currentImage});
    }

    setThumbnailsInRowNumber(onThumbnailsInRowChanged) {
        if (this.$window.innerWidth <= 600 && this.thumbnailsDisplay > 3) {
            this.thumbnailsDesktopDisplay = this.thumbnailsDisplay;
            this.thumbnailsDisplay = 3;
            if (onThumbnailsInRowChanged) {
                onThumbnailsInRowChanged();
            }
        } else if (this.$window.innerWidth > 600 && this.thumbnailsDesktopDisplay > this.thumbnailsDisplay) {
            this.thumbnailsDisplay = this.thumbnailsDesktopDisplay;
            if (onThumbnailsInRowChanged) {
                onThumbnailsInRowChanged();
            }
        }
    }

    get galleryPositionOffset() {
        return 'calc(' + (-(this.currentIndex * 100)) + '% - ' + ((this.currentIndex + 1) * 10) + 'px + ' + this.galleryPositionDelta + 'px)';
    }

    get thumbnailsPositionOffset() {
        if (this.centeredThumbnails) {
            return '0';
        }
        return (-(100 / this.thumbnailsDisplay) * this.thumbnailsPosition) + '%';
    }

    get isNextElement() {
        return !!this.images2[this.currentIndex + 1];
    }

    get isPrevElement() {
        return !!this.images2[this.currentIndex - 1];
    }

    get centeredThumbnails() {
        return this.images2.length < this.thumbnailsDisplay;
    }

    thumbnailsCenterToCurrent() {
        if (!this.thumbnailsDisplay) {
            return;
        }
        let thumbnailsMargin = Math.ceil((this.thumbnailsDisplay - 1) / 2);

        if (this.currentIndex - thumbnailsMargin < 0) {
            this.thumbnailsPosition = 0;
        } else if (this.currentIndex + thumbnailsMargin >= this.thumbnails2.length) {
            this.thumbnailsPosition = this.thumbnails2.length - this.thumbnailsDisplay;
            if (this.thumbnailsPosition < 0) {
                this.thumbnailsPosition = 0;
            }
        } else {
            this.thumbnailsPosition = this.currentIndex - thumbnailsMargin;
        }
    }

    thumbnailsForward() {
        if (this.currentIndex - this.thumbnailsPosition === this.thumbnailsDisplay - 1) {
            if ((this.thumbnailsPosition + this.thumbnailsDisplay - 1) >= (this.thumbnails2.length - 1)) {
                this.thumbnailsPosition = this.thumbnails2.length - this.thumbnailsDisplay;
            } else {
                this.thumbnailsPosition += this.thumbnailsDisplay - 1;
            }
        }
    }

    thumbnailsRewind() {
        if (this.currentIndex === this.thumbnailsPosition) {
            if (this.thumbnailsPosition - this.thumbnailsDisplay + 1 < 0) {
                this.thumbnailsPosition = 0;
            } else {
                this.thumbnailsPosition -= this.thumbnailsDisplay - 1;
            }
        }
    }

    next($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index + 1 >= this.images2.length) {
            this.setCurrent(this.images2[0].data.url);
        } else {
            this.setCurrent(this.images2[index + 1].data.url);
        }
    }

    prev($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index <= 0) {
            this.setCurrent(this.images2[this.images2.length - 1].data.url);
        } else {
            this.setCurrent(this.images2[index - 1].data.url);
        }
    }

    enableZoom($event) {
        this.zoomEnabled = true;
    }

    disableZoom($event) {
        this.zoomEnabled = false;
        this.zoomPosition = '50%';
        this.zoomDragStartPosition = null;
        this.zoomCurrentDelta = null;
    }

    toggleZoom($event) {
        this.zoomEnabled = !this.zoomEnabled;
    }

    startDrag(event) {
        if (this.zoomEnabled) {
            return;
        }

        this.dragging = true;
        this.dragStartPositionX = event.touches ? event.touches[0].clientX : event.pageX;
        this.dragStartGalleryPositionOffset = this.galleryPositionOffset;
    }

    drag(event) {
        if (!this.dragging || this.zoomEnabled || this.CropService.isModalOpen) {
            return;
        }

        this.galleryPositionDelta = (event.touches ? event.touches[0].clientX : event.pageX) - this.dragStartPositionX;

        if (this.galleryPositionDelta < 0 && this.images2[this.currentIndex + 1]) {
            this.images2[this.currentIndex + 1].loadSource((type, o, img) => {
                this.$scope.safeApply();
            });
        }
        if (this.galleryPositionDelta > 0 && this.images2[this.currentIndex - 1]) {
            this.images2[this.currentIndex - 1].loadSource((type, o, img) => {
                this.$scope.safeApply();
            });
        }
    }

    stopDrag() {
        if (this.zoomEnabled) {
            return;
        }

        this.dragging = false;

        let threshold = window.innerWidth > 600 ? 200 : 50;

        if (this.galleryPositionDelta > threshold) {
            this.prev();
        } else if (this.galleryPositionDelta < -threshold) {
            this.next();
        } else {
            this.galleryPositionDelta = 0;
        }
    }

    zoomStartDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        if (!this.zoomCurrentDelta) {
            this.zoomCurrentDelta = {x: 0, y: 0};
        }
        this.zoomDragging = true;
        this.zoomDragStartPosition = {x: event.center ? event.center.x : event.screenX, y: event.center ? event.center.y : event.screenY};
    }

    zoomDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        this.zoomPosition = 'calc(50% - ' + (this.zoomCurrentDelta.x + (this.zoomDragStartPosition.x - (event.center ? event.center.x : event.screenX))) + 'px) calc(50% - ' + (this.zoomCurrentDelta.y + (this.zoomDragStartPosition.y - (event.center ? event.center.y : event.screenY))) + 'px)';
    }

    zoomStopDrag(event) {
        if (!this.zoomEnabled) {
            return;
        }
        this.zoomCurrentDelta = {
            x: this.zoomCurrentDelta.x + this.zoomDragStartPosition.x - (event.center ? event.center.x : event.screenX),
            y: this.zoomCurrentDelta.y + this.zoomDragStartPosition.y - (event.center ? event.center.y : event.screenY)
        };
        this.dragging = false;
    }

    checkYoutubeHash(url) {
        let regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:shorts\/)?(?:[^\/\n\s]+\/)?|watch\/(?:[^\/\n\s]+\/)?|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/|\S*?[?&]video_id=|youtu\.be\/|embed\/|watch\?v(?:i)?=)([^#\&\?\n\s]{11})/;
        let match = url.match(regExp);

        if (match && match[1].length == 11) {
            return match[1];
        }

        let imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }

    trustedUrl(url) {
        return this.$sce.trustAsResourceUrl(url);
    }

    onClose(param) {

    }

    playYoutubeVideo(youtubeHash) {
        this.playVideo = youtubeHash;

        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady(youtubeHash);
    }

    onYouTubeIframeAPIReady(youtubeHash) {
        let youtubeApiInterval = setInterval(() => {
            if (typeof (window.YT) === 'object' && typeof (window.YT.Player) === 'function') {
                clearInterval(youtubeApiInterval);
                this.playYoutubeIframeVideo(youtubeHash);
            }
        }, 100);
    }

    onPlayerReady(event) {
        let isMobile = false;

        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobile = true;
        })(navigator.userAgent || navigator.vendor || window.opera);

        if (isMobile) {
            event.target.mute();
        }

        event.target.playVideo();
    }

    playYoutubeIframeVideo(youtubeHash) {
        new window.YT.Player('video-' + youtubeHash, {
            width: '100%',
            videoId: youtubeHash,
            playerVars: {'autoplay': 1, 'playsinline': 1},
            events: {
                'onReady': this.onPlayerReady
            }
        });
    }

    openImageCropModal() {
        this.CropService.isModalOpen = true;
    }
}

let galleryComponent = {
    bindings: {
        imagesList: '<',
        current: '<',
        change: '&',
        setCustomImage: '&',
        variantId: '<',
        fullscreen: '<',
        thumbnailsDisplay: '<',
        onClose: '&',
        autoScale: '@',
        voucherForm: '<',
    },
    template: galleryHtml,
    controller: GalleryController
}

export default galleryComponent;
